import { normalizeIotaName } from "./utils.js";
function isSubname(name) {
  return normalizeIotaName(name, "dot").split(".").length > 2;
}
function isNestedSubname(name) {
  return normalizeIotaName(name, "dot").split(".").length > 3;
}
function validateYears(years) {
  if (!(years > 0 && years < 6)) throw new Error("Years must be between 1 and 5");
}
function zeroCoin(tx, type) {
  return tx.moveCall({
    target: "0x2::coin::zero",
    typeArguments: [type]
  });
}
function getConfigType(iotaNamesPackageV1, innerType) {
  return `${iotaNamesPackageV1}::iota_names::ConfigKey<${innerType}>`;
}
function getRegistryKeyType(iotaNamesPackageId, innerType) {
  return `${iotaNamesPackageId}::iota_names::RegistryKey<${innerType}>`;
}
function getNameType(iotaNamesPackageV1) {
  return `${iotaNamesPackageV1}::name::Name`;
}
function getPricelistConfigType(iotaNamesPackageId) {
  return `${iotaNamesPackageId}::pricing_config::PricingConfig`;
}
function getRenewalPricelistConfigType(iotaNamesPackageId) {
  return `${iotaNamesPackageId}::pricing_config::RenewalConfig`;
}
function getNameRegistrationType(iotaNamesPackageId) {
  return `${iotaNamesPackageId}::name_registration::NameRegistration`;
}
function getSubnameRegistrationType(iotaNamesPackageId) {
  return `${iotaNamesPackageId}::subname_registration::SubnameRegistration`;
}
function getCoreConfigType(iotaNamesPackageId) {
  return `${iotaNamesPackageId}::core_config::CoreConfig`;
}
function getDenyListType(iotaNamesPackageId) {
  return `${iotaNamesPackageId}::deny_list::DenyList`;
}
function getSubnamesConfigType(iotaNamesPackageId) {
  return `${iotaNamesPackageId}::config::SubnameConfig`;
}
export {
  getConfigType,
  getCoreConfigType,
  getDenyListType,
  getNameRegistrationType,
  getNameType,
  getPricelistConfigType,
  getRegistryKeyType,
  getRenewalPricelistConfigType,
  getSubnameRegistrationType,
  getSubnamesConfigType,
  isNestedSubname,
  isSubname,
  validateYears,
  zeroCoin
};
//# sourceMappingURL=helpers.js.map
